import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { defaultShouldDehydrateQuery, QueryClient } from "@tanstack/react-query";
import { persistQueryClient } from "@tanstack/react-query-persist-client";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 1000 * 60 * 60 * 24,
    },
  },
});

const localStoragePersister = createSyncStoragePersister({
  storage: window.localStorage,
});

persistQueryClient({
  queryClient,
  persister: localStoragePersister,
  dehydrateOptions: {
    // Queries marked meta.persist: false (e.g. character portraits) opt out of localStorage
    // persistence — the persister's write is throttled (default 1s), so a page reload shortly
    // after a mutation can rehydrate a stale pre-mutation snapshot; queries relying on staleTime:
    // Infinity + explicit invalidateQueries (rather than automatic refetching) never self-correct
    // from that, so they're safer fetched fresh on every load instead of persisted at all.
    shouldDehydrateQuery: (query) => defaultShouldDehydrateQuery(query) && query.meta?.persist !== false,
  },
});

export { queryClient };
